// extracted by mini-css-extract-plugin
export default {"download":"download_download__kouhS","btn":"download_btn__Wcn0E"};